export const DAO_CODE = 'TRAINING' + '_DAO';
